import { Injectable } from '@angular/core';
// import { environment } from '../../environments/environment';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IProjectFromWeb, Project, StoryPriority, StoryState, StoryType, UserStory, IUserStory } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { FormModes } from '../common/constants.lib';
import { SettingsService } from '../settings/settings.service';
import { Settings } from '../common/obj.lib';


export abstract class CasiTrackerService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<UserStory[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/getuserstories`))
      .pipe(
        map((response: any, i) => {
          return <IUserStory[]>response;
        }),
        map(r => r.map(x => new UserStory(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class TrackerService extends CasiTrackerService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService
  ) {
    super(http, settingService);
  }

  getStoryTypes(): Promise<StoryType[]> {
    return this.apiService.getHttpCallAsPromise('getstorytypes', 'getStoryTypes');
  }

  getStoryStates(): Promise<StoryState[]> {
    return this.apiService.getHttpCallAsPromise('getstorystates', 'getStoryStates');
  }

  getStoryPriorities(): Promise<StoryPriority[]> {
    return this.apiService.getHttpCallAsPromise('getstorypriorities', 'getStoryPriorities');
  }

  getUserStories(): Promise<UserStory[]> {
    return this.apiService.getHttpCallAsPromise('getuserstories', 'getUserStories');
  }

  getUserStoriesByProjectId(projectId: number): Promise<UserStory[]> {
    return this.apiService.getHttpCallAsPromise(`getuserstories/${projectId}`, 'getUserStoriesByProjectId');
  }

}

